import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { stateComponentComplete } from '../../../models'
import { sendDataLayer } from '../../../helpers'
import FaqList from './QuestionList'

const faqs = [
    {
        question: '¿Quiénes pueden acceder a este beneficio?',
        answer: 'Este beneficio está disponible para clientes de Profuturo que hayan sido invitados directamente por alguno de nuestros canales oficiales, como correo, SMS o WhatsApp.'
    },
    {
        question: '¿Cuánto tiempo dura la suscripción',
        answer: 'Tendrás 12 meses sin costo a partir de la activación. Al finalizar, podrás decidir si deseas renovarla. Durante este tiempo, no se hará ningún cargo.'
    },
    {
        question: '¿Se requiere método de pago para activarla?',
        answer: 'No. Por ser cliente de Profuturo, tu primer año está completamente cubierto. Sólo necesitas activar tu cuenta.'
    },
    {
        question: '¿Dónde puedo escribir si tengo dudas o problemas para registrarme?',
        answer: 'Puedes contactarnos en cualquier momento al correo: soporte@soymas.la'
    }
]

const PregFrec = () => {
    const location = useLocation()

    const [render, setRender] = useState<stateComponentComplete>({ ready: false})
    useEffect(() => {
        if (render.ready) sendDataLayer('onload-pager', location.pathname)
        setRender({ ready: true})
    }, [location.pathname, render.ready])
    return (
        <main className='container_preguntas'>
            <section className='container_preg_frec'>
                <h1 className='title_preguntas'>
                    Preguntas frecuentes
                </h1>
                <FaqList faqs={faqs} />
            </section>
        </main>
    )
}

export default PregFrec